module.exports = __webpack_public_path__ + "static/media/hero-flight.80217b9b.png";